import React from 'react';
import PropTypes from 'prop-types';

import { ICONS } from 'staticAssets/icons/iconList';

class IconSvg extends React.PureComponent {
  render () {

    const iconObj = ICONS[this.props.iconName];

    if (!iconObj) {
      return null;
    }

    const title = this.props.svgTitle || iconObj.title;

    let { height, width } = iconObj;

    if (this.props.size) {
      height = this.props.size;
      width = this.props.size;
    }

    const paths = iconObj.path.map((path, index) => {

      // eslint-disable-next-line react/no-array-index-key
      return <path d={path.d} key={index} transform={path.transform ? path.transform : ''} />;
    });

    return (
      <svg
        aria-hidden={this.props.ariaHidden}
        className={this.props.className}
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        width={width}
        height={height}
        fill={this.props.fill}
        role="img"
        viewBox={`0 0 ${iconObj.width} ${iconObj.height}`}
      >
        {!this.props.ariaHidden && <title>{title}</title>}
        {paths}
        {iconObj.rect && (
          <rect
            x={iconObj.rect.x}
            y={iconObj.rect.y}
            width={iconObj.rect.width}
            height={iconObj.rect.height}
          />
        )}
        {iconObj.polygon && <polygon points={iconObj.polygon.points} />}
      </svg>
    );
  }
}

IconSvg.propTypes = {
  ariaHidden: PropTypes.bool,
  className: PropTypes.string,
  iconName: PropTypes.string.isRequired,
  size: PropTypes.number,
  svgTitle: PropTypes.string,
  fill: PropTypes.string
};

export default IconSvg;
